export class AnalyzerChartDataInputParameters {
    constructor(chartType, unerlierPrice, interestRate, paperPositionsInfo, optionCalculator) {
        this.chartType = chartType;
        this.underlierPrice = unerlierPrice;
        this.interestRate = interestRate;
        this.paperPositionsInfo = paperPositionsInfo;
        this.optionCalculator = optionCalculator;
    }
}
export class AnalyzerChartDataPaperPositionInfo {
    constructor(paperPosition, greeks) {
        this.paperPosition = paperPosition;
        this.greeks = greeks;
    }
}
